
import { Suspense } from 'react'
import { FallbackView } from '../../_metronic/partials'

import AllRoutes from '../allRoutes'
import { allroutesHandler } from './allRoutesHandler'


export function PrivateRoutes() {
  allroutesHandler()

  return (
    <Suspense fallback={<FallbackView />}>
      <AllRoutes></AllRoutes>
    </Suspense>
  )
}
